for (const choiceType of ['zodiac', 'packaging']) {
  const elementName = `dongxi-${choiceType}-picker`;
  if (customElements.get(elementName)) continue;
  customElements.define(elementName, class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', (event) => {
        if (!event.target.matches(`[data-${choiceType}-option]`)) return;
        this.querySelector(`[name="properties[_${choiceType}_code]"]`).value = event.target.getAttribute(`data-${choiceType}-code`);
        this.removeAttribute('data-invalid');
        this.querySelector('.dx-zodiac__error').hidden = true;
        this.querySelector('fieldset').removeAttribute('aria-invalid');
        document.getElementById(this.dataset.formId)?.closest('product-form')?.handleErrorMessage();
      });
    }
  });
}
